import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 2.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "presidente" },
    ans2: { value: "", valid: "", correctValue: "jueces" },
    ans3: { value: "", valid: "", correctValue: "congresistas" },
  });
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[1];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: ` ${modulo11.content[0].activities[2].name}`,
    linkNext: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[2].path}`,
    titlePrev: `${modulo11.content[0].activities[0].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-12 mb-1">
          <ul className="">
            <li>
              Llena los siguientes espacios en blanco con las autoridades que
              aparecen en la actividad anterior.
            </li>
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div>presidente</div>
              <div>congresistas</div>
              <div>jueces</div>
            </div>
          </Card>
        </div>
        <div className="col-md-4">
          <Card>
            <p>
              El{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              gobierna el país.
            </p>
          </Card>
        </div>
        <div className="col-md-4">
          <Card>
            <p>
              Los{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              resuelven los conflictos, protegen los derechos de las personas y
              castigan a quienes cometen delitos.
            </p>
          </Card>
        </div>
        <div className="col-md-4">
          <Card>
            <p>
              Los{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
              representan a los ciudadanos, hacen las leyes y fiscalizan.
            </p>
          </Card>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo11.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Al terminar, lean las oraciones con las funciones de cada autoridad
          (pueden ser hombres o mujeres).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
